import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Zap, Download, Loader2, XCircle } from 'lucide-react';

export default function Share() {
    const { token } = useParams();
    const [state, setState] = useState({ loading: true, data: null, error: null });

    useEffect(() => {
        api.get(`/share/${token}`)
            .then((r) => setState({ loading: false, data: r.data, error: null }))
            .catch((e) => setState({ loading: false, data: null, error: e.response?.data?.detail || 'Link not available' }));
    }, [token]);

    return (
        <div className="min-h-screen grid place-items-center px-6" data-testid="share-page">
            <div className="max-w-md w-full text-center border border-border p-10 bg-card">
                <div className="mx-auto h-12 w-12 grid place-items-center bg-[#FF6B35] text-white mb-4">
                    <Zap className="h-6 w-6" strokeWidth={2.5} />
                </div>
                {state.loading && (
                    <div>
                        <Loader2 className="h-8 w-8 mx-auto text-[#FF6B35] animate-spin" />
                        <p className="mt-4 text-sm text-muted-foreground">Preparing your file…</p>
                    </div>
                )}
                {state.error && (
                    <div>
                        <XCircle className="h-10 w-10 mx-auto text-destructive" />
                        <h1 className="mt-4 font-heading text-2xl">Link unavailable</h1>
                        <p className="mt-2 text-sm text-muted-foreground">{state.error}</p>
                    </div>
                )}
                {state.data && (
                    <div>
                        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Shared via Magnidrop</p>
                        <h1 className="mt-3 font-heading text-2xl break-words" data-testid="share-filename">{state.data.filename}</h1>
                        <p className="mt-2 text-sm text-muted-foreground">
                            {(state.data.size_bytes / 1024 ** 3).toFixed(2)} GB
                        </p>
                        <a href={state.data.url} target="_blank" rel="noreferrer">
                            <Button data-testid="share-download-btn" className="mt-6 w-full bg-[#FF6B35] hover:bg-[#E55C2A] text-white">
                                <Download className="h-4 w-4 mr-2" /> Download file
                            </Button>
                        </a>
                        {state.data.expires_at && (
                            <p className="mt-4 text-xs text-muted-foreground">
                                Expires {new Date(state.data.expires_at).toLocaleString()}
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
